<template>
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m11.1644 10 8.5944-8.59444c.3216-.32153.3216-.842875 0-1.164409-.3215-.3215346-.8428-.3215346-1.1644 0L10 8.83559 1.40556.241151c-.32153-.3215346-.842875-.3215346-1.164409 0-.3215346.321534-.3215346.842879 0 1.164409L8.83559 10 .241151 18.5944c-.3215346.3216-.3215346.8429 0 1.1644.160767.1608.371486.2412.582206.2412.210723 0 .421443-.0804.582203-.2412L10 11.1644l8.5944 8.5944c.1608.1608.3721.2412.5822.2412.2102 0 .4215-.0804.5822-.2412.3216-.3215.3216-.8428 0-1.1644L11.1644 10Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconClose",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
